import Oidc from "oidc-client";
import oidcConfig from "../../helpers/oidcConfig";

const userManager = new Oidc.UserManager(oidcConfig);

export async function getUser() {
  return await userManager.getUser();
}

export async function login() {
  return await userManager.signinRedirect();
}

export function logout() {
  return userManager.signoutRedirect();
}
